<template>
  <div class="col-12 bg-white rounded mt-n3">
    <validation-observer
      ref="returnToPreviousStatusForm"
      v-slot="{}"
      tag="form"
    >
      <div class="row mb-n3">
        <div class="col-12 mt-2">
          <p>
            <i
              class="h6 fas fas fa-calendar-day text-orange mr-2 font-weight-bold"
            />
            <span class="font-weight-bold color-gray-7">
              {{ title }}
            </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <validation-provider
            v-slot="{ errors }"
            name="licenseDueDate"
            rules="required"
          >
            <label class="data-title mb-0">Fecha:</label>
            <custom-date-picker
              v-model="model.contractDeterminationDate"
              :class-container="'w-100'"
              :custom-error-msg="'La fecha es requerida.'"
              :error="errors[0]"
              format="dd/MMM./yyyy"
              :min-date="minDate"
            />
          </validation-provider>
        </div>
        <div class="col-12 mt-3">
          <validation-provider
            v-slot="{ errors }"
            name="approvalComment"
            rules="required"
          >
            <label class="data-title mb-0">Razón:</label>
            <custom-text-area
              v-model="model.approvalDateModificationReason"
              :count-classes="['float-right']"
              custom-error-msg="La razón es requerida."
              :error="errors[0]"
              :maxlength="3000"
              show-char-count
            />
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col-12 mt-3 mr-3">
          <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
            <div class="bd-highlight ml-2">
              <action-button
                i="fas fa-save fa-lg"
                text="Guardar"
                variant="success"
                @click="submitForm()"
              />
            </div>
            <div class="mx-0 bd-highlight">
              <action-button
                id="modal-btn-cancelar"
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger"
                @click="$emit('cancel')"
              />
            </div>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import alert from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomDatePicker from 'custom-date-picker';
import CustomTextArea from 'CustomTextArea';

import { modifyApprovalDate as _modifyApprovalDate } from '@/services/uspqrp/contract.api.js';

export default {
  name: 'ContractModifyApprovalDate',
  components: {
    ValidationProvider,
    ActionButton,
    CustomDatePicker,
    CustomTextArea,
  },
  mixins: [alert],
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        contractDeterminationDate: null,
        approvalDateModificationReason: null,
        contractDeterminationDateStaging: null,
      },
    };
  },
  computed: {
    title() {
      return 'Modificar fecha de aprobación';
    },
    minDate() {
      if (!this.data.submittedContractDate) {
        return null;
      }
      const d = new Date(this.data.submittedContractDate);
      return d.setDate(d.getDate() - 1);
    },
  },
  mounted() {
    if (this.data && this.data.additionalInformation) {
      this.model.contractDeterminationDate = this.data.additionalInformation.approvalDate;

    }
  },
  methods: {
    async submitForm() {
      const isFormValid = await this.$refs.returnToPreviousStatusForm.validate();
      if (!isFormValid) {
        this.ShowToast('Alerta', 'Debe completar los campos requeridos.', 'error');
        return;
      }
      if(this.$formatDate(this.data.additionalInformation.approvalDate) == 
         this.$formatDate(this.model.contractDeterminationDate))
      {
        this.ShowToast('Alerta', 'La fecha de aprobación debe ser diferente a la actual.', 'error');
        return;
      }
      await this.submitContractServiceStartDate();
    },
    async submitContractServiceStartDate() {
      const warningMessage =
        '¿Está seguro(a) que desea modificar la fecha de aprobación?';
      const successMessage =
        'La fecha de aprobación ha sido actualizada exitosamente.';

      const answer = await this.ShowCancelModal(
        'Confirmación',
        warningMessage,
        'Sí',
        'No'
      );

      if (!answer) {
        return;
      }

      const payload = {
        contractId: this.data.contractId,
        contractApprovalDate: this.model.contractDeterminationDate,
        approvalDateModificationReason: this.model
          .approvalDateModificationReason,
      };
      const { data } = await _modifyApprovalDate(payload).catch((error) => {
        this.ShowToast('Alerta', `${error.message}.`, 'error');
        return { data: false };
      });

      if (data) this.ShowToast(`Confirmación`, successMessage, 'success');

      this.$emit('save', data);
    },
  },
};
</script>
